<template>
	<el-container class="group-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="group-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="创建群聊" @click="onCreateGroup()"></el-button>
			</div>
			<el-scrollbar class="group-items">
				<div v-for="(groups, i) in groupValues" :key="i">
					<div class="letter">{{ groupKeys[i] }}</div>
					<div v-for="group in groups" :key="group.id">
						<group-item :group="group" :active="group.id == activeGroup.id"
							@click.native="onActiveItem(group)">
						</group-item>
					</div>
					<div v-if="i < groupValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container">
			<div class="header" v-show="activeGroup.id">{{ activeGroup.showGroupName }}({{ showMembers.length }})</div>
			<div class="empty-state" v-show="!activeGroup.id">
				<div class="empty-state-frame">
					<span class="icon iconfont icon-group"></span>
					<div class="empty-state-title">选择群聊查看资料</div>
					<div class="empty-state-text">群成员、公告和群设置将在这里显示</div>
				</div>
			</div>
			<div class="container-box" v-show="activeGroup.id">
				<div class="group-info">
					<div>
						<file-upload v-show="isOwner" class="avatar-uploader" :action="imageAction" :showLoading="true"
							:maxSize="maxSize" @success="onUploadSuccess"
							:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
							<img v-if="activeGroup.headImage" :src="activeGroup.headImage" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</file-upload>
						<head-image v-show="!isOwner" class="avatar" :size="160" :url="activeGroup.headImage"
							:name="activeGroup.showGroupName" radius="10%" @click.native="showFullImage()">
						</head-image>
						<el-button class="send-btn" icon="el-icon-position" type="primary"
							@click="onSendMessage(activeGroup)">发消息
						</el-button>
					</div>
					<el-form class="form" label-width="130px" :model="activeGroup" :rules="rules" size="small"
						ref="groupForm">
						<el-form-item label="群聊名称" prop="name">
							<el-input v-model="activeGroup.name" :disabled="!isOwner" maxlength="20"></el-input>
						</el-form-item>
						<el-form-item label="群主">
							<el-input :value="ownerName" disabled></el-input>
						</el-form-item>
						<el-form-item label="群名备注">
							<el-input v-model="activeGroup.remarkGroupName" :placeholder="activeGroup.name"
								maxlength="20"></el-input>
						</el-form-item>
						<el-form-item label="我在本群的昵称">
							<el-input v-model="activeGroup.remarkNickName" maxlength="20"
								:placeholder="userStore.userInfo.nickName"></el-input>
						</el-form-item>
						<el-form-item label="群公告">
							<el-input v-model="activeGroup.notice" :disabled="!isOwner" type="textarea" :rows="3"
								maxlength="1024" placeholder="群主未设置"></el-input>
						</el-form-item>
						<div>
							<el-button type="warning" @click="onInviteMember()">邀请</el-button>
							<el-button type="success" @click="onSaveGroup()">保存</el-button>
							<el-button type="danger" v-show="!isOwner" @click="onQuit(activeGroup)">退出</el-button>
							<el-button type="danger" v-show="isOwner" @click="onDissolve(activeGroup)">解散</el-button>
						</div>
					</el-form>
				</div>
				<el-divider content-position="center"></el-divider>
				<el-scrollbar ref="scrollbar" :style="'height: ' + scrollHeight + 'px'">
					<div class="member-items">
						<div class="member-tools">
							<div class="tool-btn" title="邀请好友进群聊" @click="onInviteMember()">
								<i class="el-icon-plus"></i>
							</div>
							<div class="tool-text">邀请</div>
						</div>
						<div class="member-tools" v-if="isOwner">
							<div class="tool-btn" title="选择成员移出群聊" @click="onRemoveMember()">
								<i class="el-icon-minus"></i>
							</div>
							<div class="tool-text">移除</div>
							<group-member-selector ref="removeSelector" title="选择成员进行移除" :group="activeGroup"
								@complete="onRemoveComplete"></group-member-selector>
						</div>
						<div v-for="(member, idx) in showMembers" :key="member.id">
							<group-member v-if="idx < showMaxIdx" class="member-item" :member="member"></group-member>
						</div>
					</div>
				</el-scrollbar>
			</div>
		</el-container>
		<group-member-invite ref="groupMemberInvite" :groupId="activeGroup.id" :members="groupMembers"
			@reload="reloadMembers" @success="onCreateGroupSuccess"></group-member-invite>
	</el-container>
</template>


<script>
import GroupItem from '../components/group/GroupItem';
import FileUpload from '../components/common/FileUpload';
import GroupMember from '../components/group/GroupMember.vue';
import GroupMemberInvite from '../components/group/GroupMemberInvite.vue';
import GroupMemberSelector from '../components/group/GroupMemberSelector.vue';
import HeadImage from '../components/common/HeadImage.vue';
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "group",
	components: {
		GroupItem,
		GroupMember,
		FileUpload,
		GroupMemberInvite,
		GroupMemberSelector,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			maxSize: 5 * 1024 * 1024,
			activeGroup: {},
			showMaxIdx: 150,
			rules: {
				name: [{
					required: true,
					message: '请输入群聊名称',
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		onCreateGroup() {
			this.$refs.groupMemberInvite.openCreate();
		},
		async onCreateGroupSuccess(group) {
			await this.groupStore.addGroup(group);
			await this.groupStore.refreshMember(group.id);
			await this.onSendMessage(group);
		},
		onActiveItem(group) {
			this.showMaxIdx = 150;
			// store数据不能直接修改，所以深拷贝一份内存
			this.activeGroup = JSON.parse(JSON.stringify(group));
			// 重新加载群成员
			this.reloadMembers();
		},
		onInviteMember() {
			this.$refs.groupMemberInvite.open();
		},
		onRemoveMember() {
			// 群主不显示
			let hideIds = [this.activeGroup.ownerId];
			this.$refs.removeSelector.open(50, [], [], hideIds);
		},
		onRemoveComplete(members) {
			let userIds = members.map(m => m.userId);
			let data = {
				groupId: this.activeGroup.id,
				userIds: userIds
			}
			this.$http({
				url: "/group/members/remove",
				method: 'delete',
				data: data
			}).then(() => {
				this.reloadMembers();
				this.$message.success(`您移除了${userIds.length}位成员`);
			})
		},
		onUploadSuccess(data) {
			this.activeGroup.headImage = data.originUrl;
			this.activeGroup.headImageThumb = data.thumbUrl;
		},
		onSaveGroup() {
			this.$refs['groupForm'].validate((valid) => {
				if (valid) {
					let vo = this.activeGroup;
					this.$http({
						url: "/group/modify",
						method: "put",
						data: vo
					}).then((group) => {
						this.groupStore.updateGroup(group);
						this.chatStore.updateFromGroup(group);
						this.$message.success("修改成功");
					})
				}
			});
		},
		onDissolve(group) {
			this.$confirm(`确认要解散'${group.name}'吗?`, '确认解散?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/group/delete/${group.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success(`群聊'${group.name}'已解散`);
					this.groupStore.removeGroup(group.id);
					this.reset();
				});
			})
		},
		onQuit(group) {
			this.$confirm(`确认退出'${group.showGroupName}',并清空聊天记录吗？`, '确认退出?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$http({
					url: `/group/quit/${group.id}`,
					method: 'delete'
				});
				this.groupStore.removeGroup(group.id);
				// 删除会话
				const data = { chatId: group.id }
				await this.$http({
					url: `/message/group/deleteChat`,
					method: 'delete',
					data: data
				});
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id)
				this.chatStore.remove(convKey);
				this.$message.success(`您已退出'${group.name}'`);
				this.reset();

			})
		},
		async onSendMessage(group) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id)
			const chatInfo = {
				key: convKey,
				type: this.$enums.CONVERSATION_TYPE.GROUP,
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb,
				isDnd: group.isDnd
			};
			await this.chatStore.openChat(chatInfo);
			await this.chatStore.moveTop(convKey)
			this.chatStore.setActive(convKey);
			this.$router.push("/home/chat");
		},
		onScroll(e) {
			const scrollbar = e.target;
			// 滚到底部
			if (scrollbar.scrollTop + scrollbar.clientHeight >= scrollbar.scrollHeight - 30) {
				if (this.showMaxIdx < this.showMembers.length) {
					this.showMaxIdx += 50;
				}
			}
		},
		showFullImage() {
			if (this.activeGroup.headImage) {
				this.$eventBus.$emit("openFullImage", this.activeGroup.headImage);
			}
		},
		reloadMembers() {
			this.groupStore.refreshMember(this.activeGroup.id);
		},
		reset() {
			this.activeGroup = {};
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		ownerName() {
			let member = this.groupMembers.find(m => m.userId == this.activeGroup.ownerId);
			return member && member.showNickName;
		},
		isOwner() {
			return this.activeGroup.ownerId == this.userStore.userInfo.id;
		},
		imageAction() {
			return `/image/upload?thumbSize=20`;
		},
		groupMap() {
			// 按首字母分组
			let map = new Map();
			this.groupStore.groups.forEach((g) => {
				if (g.quit || (this.searchText && !g.showGroupName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(g.showGroupName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (map.has(letter)) {
					map.get(letter).push(g);
				} else {
					map.set(letter, [g]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		groupKeys() {
			return Array.from(this.groupMap.keys());
		},
		groupValues() {
			return Array.from(this.groupMap.values());
		},
		showMembers() {
			return this.groupMembers.filter((m) => !m.quit)
		},
		scrollHeight() {
			return Math.min(300, 80 + this.showMembers.length / 10 * 80);
		},
		groupMembers() {
			let group = this.groupStore.findGroup(this.activeGroup.id);
			return group ? group.members : [];
		}
	},
	mounted() {
		let scrollWrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
		scrollWrap.addEventListener('scroll', this.onScroll);
	}
}
</script>

<style lang="scss">
.group-page {
	height: 100%;
	color: var(--im-tech-text);
	background: transparent;

	.header {
		height: 60px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		padding: 0 12px;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(43, 223, 255, 0.18);
		background:
			linear-gradient(180deg, rgba(10, 42, 82, 0.42), rgba(5, 20, 42, 0.3));

		.search-text {
			flex: 1;

			.el-input__inner {
				height: 38px;
				color: var(--im-tech-text);
				background: rgba(2, 13, 30, 0.46);
				border: 1px solid rgba(43, 223, 255, 0.32);
				border-radius: 8px;
				box-shadow: inset 0 0 18px rgba(0, 112, 255, 0.12);

				&:hover,
				&:focus {
					border-color: rgba(43, 223, 255, 0.78);
					box-shadow: 0 0 0 2px rgba(43, 223, 255, 0.12), inset 0 0 18px rgba(0, 112, 255, 0.16);
				}

				&::placeholder {
					color: rgba(167, 198, 224, 0.64);
				}
			}

			.el-input__prefix {
				color: rgba(43, 223, 255, 0.72);
			}
		}

		.add-btn {
			width: 38px;
			height: 38px;
			padding: 0;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
			background:
				linear-gradient(135deg, rgba(8, 125, 255, 0.32), rgba(43, 223, 255, 0.14));
			color: var(--im-tech-cyan);
			transition: all 0.3s ease;
			font-weight: 600;
			border: 1px solid rgba(43, 223, 255, 0.36);
			box-shadow: inset 0 0 12px rgba(43, 223, 255, 0.08);

			&:hover {
				background:
					linear-gradient(135deg, rgba(8, 125, 255, 0.62), rgba(43, 223, 255, 0.34));
				transform: scale(1.05);
				color: #fff;
				border-color: rgba(43, 223, 255, 0.78);
				box-shadow: 0 0 18px rgba(43, 223, 255, 0.3);
			}
		}
	}

	.group-items {
		flex: 1;
		background:
			linear-gradient(180deg, rgba(6, 25, 50, 0.42), rgba(3, 14, 32, 0.36));

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: rgba(141, 169, 197, 0.86);
			font-weight: 600;
		}
	}

	.container {
		display: flex;
		flex-direction: column;
		min-width: 0;
		color: var(--im-tech-text);
		background: rgba(2, 15, 31, 0.08);

		.header {
			display: flex;
			justify-content: space-between;
			padding: 0 12px;
			line-height: 50px;
			font-size: var(--im-font-size-larger);
			color: var(--im-tech-text);
			font-weight: 600;
			border-bottom: 1px solid rgba(43, 223, 255, 0.28);
			background:
				linear-gradient(180deg, rgba(10, 42, 82, 0.38), rgba(5, 20, 42, 0.24));
		}

		.el-divider--horizontal {
			margin: 16px 0;
			background-color: rgba(43, 223, 255, 0.18);
		}

		.empty-state {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			color: var(--im-tech-text-muted);
			background-color: rgba(3, 16, 35, 0.18);
			background-image:
				linear-gradient(rgba(43, 223, 255, 0.06) 1px, transparent 1px),
				linear-gradient(90deg, rgba(43, 223, 255, 0.06) 1px, transparent 1px),
				linear-gradient(180deg, rgba(7, 32, 62, 0.24), rgba(2, 10, 24, 0.3));
			background-size: 42px 42px, 42px 42px, 100% 100%;
		}

		.empty-state-frame {
			min-width: 260px;
			padding: 28px 34px;
			border: 1px solid rgba(43, 223, 255, 0.24);
			border-radius: 8px;
			background: rgba(3, 17, 36, 0.34);
			box-shadow: inset 0 0 22px rgba(43, 223, 255, 0.06);
		}

		.empty-state-frame .icon {
			display: block;
			margin-bottom: 12px;
			color: var(--im-tech-cyan);
			font-size: 34px;
			text-shadow: 0 0 18px rgba(43, 223, 255, 0.5);
		}

		.empty-state-title {
			color: var(--im-tech-text);
			font-size: var(--im-font-size-large);
			font-weight: 600;
			line-height: 28px;
		}

		.empty-state-text {
			margin-top: 4px;
			color: var(--im-tech-text-muted);
			font-size: var(--im-font-size-small);
			line-height: 22px;
		}

		.container-box {
			overflow: auto;
			padding: 20px;
			flex: 1;

			.group-info {
				display: flex;
				padding: 5px 20px;

				.form {
					flex: 1;
					padding-left: 40px;
					max-width: 700px;
				}

				.avatar-uploader {
					--width: 160px;
					text-align: left;

					.el-upload {
						border: 1px dashed rgba(43, 223, 255, 0.38) !important;
						border-radius: 8px;
						cursor: pointer;
						position: relative;
						overflow: hidden;
						background: rgba(3, 17, 36, 0.36);
					}

					.el-upload:hover {
						border-color: rgba(43, 223, 255, 0.78);
						box-shadow: 0 0 16px rgba(43, 223, 255, 0.18);
					}

					.avatar-uploader-icon {
						font-size: 28px;
						color: var(--im-tech-cyan);
						width: var(--width);
						height: var(--width);
						line-height: var(--width);
						text-align: center;
					}

					.avatar {
						width: var(--width);
						height: var(--width);
						display: block;
					}
				}

				.send-btn {
					margin-top: 12px;
				}

				.form {
					.el-form-item__label {
						color: rgba(190, 220, 244, 0.86) !important;
					}

					.el-input__inner,
					.el-textarea__inner {
						color: var(--im-tech-text) !important;
						background: rgba(2, 13, 30, 0.46) !important;
						border-color: rgba(43, 223, 255, 0.28) !important;

						&::placeholder {
							color: rgba(167, 198, 224, 0.58) !important;
						}
					}

					.el-input.is-disabled .el-input__inner,
					.el-textarea.is-disabled .el-textarea__inner {
						color: rgba(232, 247, 255, 0.72) !important;
						background: rgba(7, 29, 58, 0.52) !important;
						border-color: rgba(43, 223, 255, 0.2) !important;
						-webkit-text-fill-color: rgba(232, 247, 255, 0.72);
					}
				}
			}

			.member-items {
				padding: 0 12px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				text-align: center;

				.member-item {
					margin-right: 5px;
				}

				.member-tools {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 60px;

					.tool-btn {
						width: 38px;
						height: 38px;
						line-height: 38px;
						border: 1px solid rgba(43, 223, 255, 0.32);
						border-radius: 8px;
						color: var(--im-tech-cyan);
						background: rgba(43, 223, 255, 0.08);
						font-size: 14px;
						cursor: pointer;
						box-sizing: border-box;
						transition: all 0.2s ease;

						&:hover {
							border-color: rgba(43, 223, 255, 0.76);
							box-shadow: 0 0 14px rgba(43, 223, 255, 0.24);
						}
					}

					.tool-text {
						font-size: var(--im-font-size-smaller);
						text-align: center;
						width: 100%;
						height: 30px;
						line-height: 30px;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						color: var(--im-tech-text-muted);
					}
				}

			}
		}
	}
}
</style>
